import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress } from "@mui/material";
import { AddShoppingCart, Warning } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export enum ECartBtnStatus {
    normal,
    disabled,
    outOfStock,
    notLoggedIn
}

interface Props {
    status: ECartBtnStatus;
    loading: boolean;
    onPress?: () => any;
    color?: string;
}

const AddToCartBtn: React.FC<Props> = ({ status, loading, onPress, color }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const navigate = useNavigate();

    const handlePress = () => {
        if (dialogOpen || loading) return;

        if (status === ECartBtnStatus.notLoggedIn) {
            navigate('/login');
        } else if (status === ECartBtnStatus.outOfStock) {
            setDialogOpen(true);
        } else if (onPress) {
            onPress();
        }
    }

    const getText = () => {
        if (loading) return "Aggiungo al carrello";
        switch (status) {
            case ECartBtnStatus.normal: return "Aggiungi al carrello";
            case ECartBtnStatus.notLoggedIn: return "Effettua l'accesso";
            case ECartBtnStatus.outOfStock: return "Prodotto esaurito";
            case ECartBtnStatus.disabled: return "Aggiungi al carrello";
        }
    }

    const getIcon = () => {
        if (loading) return <CircularProgress size={28} style={{ color: "#fff" }} />;
        return (status === ECartBtnStatus.normal || status === ECartBtnStatus.disabled)
            ? <AddShoppingCart />
            : <Warning />;
    }

    const getColor = () => {
        switch (status) {
            case ECartBtnStatus.normal: return color ?? "#b3071b";
            case ECartBtnStatus.disabled: return "rgb(233, 233, 233)";
            case ECartBtnStatus.notLoggedIn:
            case ECartBtnStatus.outOfStock: return "#ff9800";
        }
    }

    const getTextColor = () => (status === ECartBtnStatus.normal ? "white" : "black");
    const getDisabled = () => status === ECartBtnStatus.disabled;

    const getDialogTitle = () => {
        switch (status) {
            case ECartBtnStatus.notLoggedIn: return "Effettua l'accesso";
            case ECartBtnStatus.outOfStock: return "Questo prodotto non è disponibile";
            default: return "None";
        }
    }

    const getDialogText = () => {
        switch (status) {
            case ECartBtnStatus.notLoggedIn: return "Devi effettuare l'accesso per poter aggiungere prodotti al carrello";
            case ECartBtnStatus.outOfStock: return "Contatta il tuo consulente commerciale";
            default: return "None";
        }
    }

    return (
        <>
            <Button
                onClick={handlePress}
                disabled={getDisabled()}
                variant="contained"
                startIcon={getIcon()}
                style={{ padding: '3%', width: '100%', backgroundColor: getColor(), color: getTextColor() }}
            >
                {getText()}
            </Button>
            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
            >
                <DialogTitle>{getDialogTitle()}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{getDialogText()}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setDialogOpen(false)}>Ok</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default AddToCartBtn;
